import { axiosBase } from 'utils';

const axios = axiosBase.create();

export function yardiSyncCompaniesService(params) {
  return axios.get('/yardi-sync/companies', { params });
}

export function yardiSyncFiltersService(params) {
  return axios.get('/yardi-sync/filters', { params });
}
